import type { HTMLAttributes, ReactNode } from "react";

import { Mark } from "@/components/brand/Mark";
import { cn } from "@/lib/cn";

export interface EmptyStateProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  description?: string;
  /** One action (a Button or Link). */
  action?: ReactNode;
  /** Hide the greyed mark (dense lists). */
  compact?: boolean;
  /** The title's heading level: `h1` when the empty state is the whole screen (not found). */
  heading?: "h1" | "h2";
}

/** Greyed mark, title, one sentence, one action. Centred: one of the few centred things. */
export function EmptyState({
  title,
  description,
  action,
  compact = false,
  heading: Heading = "h2",
  className,
  ...props
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        "flex flex-col items-center gap-3 rounded-card border border-dashed border-line bg-surface/60 px-6 py-14 text-center",
        compact && "py-9",
        className,
      )}
      {...props}
    >
      {compact ? null : <Mark size={40} tone="muted" className="text-muted" />}
      <Heading className="text-lg">{title}</Heading>
      {description ? <p className="max-w-(--measure) text-base text-muted">{description}</p> : null}
      {action ? <div className="mt-2">{action}</div> : null}
    </div>
  );
}
